// extracted by mini-css-extract-plugin
export default {"tips":"_32SO0","toolTipShow":"_3aOcJ","animate":"_2JUyj"};